var _module_exports ="<div ng-repeat=\"task in sysRole.BusinessTasks | orderBy: Name\">\n    <strong>{{ task.Name }}</strong>\n</div>";;
var path = '/app/Main/supervisor/supervisorAuthorizingUserRequest/displayBusinessTasks.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;